// extracted by mini-css-extract-plugin
export default {"wrapper":"Money_wrapper__FXjFj","list":"Money_list__5iy-o","topAction":"Money_topAction__tSvRh","noMoneyWithFilter":"Money_noMoneyWithFilter__JWTC1"};